import {EMDMActions, FinishStageMdmLoadingProgression, MDMActions} from "../../actions/mdm/mdm.actions";
import {IMDMState, initialMDMState} from "../../state/mdm/mdm.state";
import {IMDMHierarchy} from "@retail-data-factory/rdf-angular-types-api";

export const mdmReducers = (
  state = initialMDMState,
  action: MDMActions

):IMDMState =>{
  switch (action.type) {
    case EMDMActions.ClearMDMStore:{
      console.log('clear MDMStore reducer');
      return {
        //types: Array.from([]),
        ///hierarchy: Array.from([]),
        ...state,
        progress: 0,
        isLoaded: false

      };
    }
    case EMDMActions.InitMDMStore:{
      console.log('init MDMStore reducer');
      return {
        //types: Array.from([]),
        ///hierarchy: Array.from([]),
        ...state,
        progress: 0,
        isLoaded: false

      };
    }

    case EMDMActions.LoadTypes: {
      console.log('Load Types reducer');
      return {
        ...state
      };
    }


    case EMDMActions.LoadTypesSuccess:{
      console.log('LoadTypesSuccess reducer', state.hierarchy, action);
      return {
        ...state,
        types: Array.from(action.payload),
        hierarchy: Array.from([])
      };
    }
    case EMDMActions.LoadTypesFailure:{
      return {
        types: Array.from([]),
        hierarchy: Array.from([]),
        progress: 0,
        isLoaded:true
      };
    }

    case EMDMActions.LoadAllHierarchy:{
      return {
        ...state
      };
    }
    case EMDMActions.LoadAllHierarchySuccess:{
      return {
        ...state,
        hierarchy:Array.from(action.payload)
      };
    }
    case EMDMActions.LoadAllHierarchyFailure:{
      return {
        ...state,
        hierarchy:Array.from([])
      };
    }

    case EMDMActions.LoadHierarchyList:{
      console.log('LoadHierarchyList reducer', state.hierarchy);
      return {
        ...state
      };
    }
    case EMDMActions.LoadHierarchyListSuccess:{
      const tmp = Array.from(state.hierarchy);
      console.log(`LoadHierarchyListSuccess reducer state`,state.hierarchy);

      console.log(`LoadHierarchyListSuccess reducer action`,action.payload);
      action.payload.forEach((item) =>{
        const newHierarchy:IMDMHierarchy = {
          ...item
        };
        tmp.push(newHierarchy);
      });
      console.log(`LoadHierarchyListSuccess reducer result`,tmp);
      return {
        ...state,
        hierarchy:Array.from(tmp)
      };
    }
    /*
    case EMDMActions.LoadHierarchyListFailure:{
      return {
        ...state,
        hierarchy:[]
      };
    }
    */

    case EMDMActions.LoadHierarchyLevels:{
      console.log('LoadHierarchyLevels', state.hierarchy);
      return {
        ...state
      };
    }
    case EMDMActions.LoadHierarchyLevelsSuccess:{
      console.log('LoadHierarchyLevelsSuccess', state.hierarchy,action );
      const allHierarchy = Array.from(state.hierarchy);
      const hierarchy = state.hierarchy.find(item=>item.id === action.payload.hierCode);
      if (hierarchy) {
        hierarchy.levels = Array.from(action.payload.levels);
      }

      return {
        ...state,
        hierarchy:Array.from(allHierarchy)
      };
    }

    case EMDMActions.LoadHierarchyDetailSuccess:{
      console.log('LoadHierarchyDetailSuccess', state.hierarchy, action);
      const allHierarchy = Array.from(state.hierarchy);
      if (action.payload) {
        const hierarchy = state.hierarchy.find(item => item.id === action.payload.hierCode);
        if (hierarchy) {
          hierarchy.levels = Array.from(action.payload.levels);
        }
      }
      return {
        ...state,
        hierarchy:Array.from(allHierarchy)
      };
    }

    case EMDMActions.StartMdmLoadingProgression: {
      return {
        ...state,
        progress: action.payload.stages
      };
    }
    case EMDMActions.FinishStageMdmLoadingProgression: {
      const newProgress = state.progress -1<0?0:state.progress -1;
      return {
        ...state,
        progress: newProgress,
        isLoaded: newProgress === 0
      };
    }
    case EMDMActions.FinishAllMdmLoadingProgression: {
      return {
        ...state,
        progress: 0,
        isLoaded: true
      };
    }
    default:
      return state;
  }
};

